module.exports = `:root {
  --primitiveColorShale25: #09090A;
  --primitiveColorShale50: #101112;
  --primitiveColorShale100: #1a1b1e;
  --primitiveColorShale150: #24262a;
  --primitiveColorShale200: #2e3036;
  --primitiveColorShale300: #43474f;
  --primitiveColorShale400: #525762;
  --primitiveColorShale750: #b7b9be;
  --primitiveColorShale850: #d3d4d7;
  --primitiveColorShale900: #e2e2e4;
  --primitiveColorShale950: #f0f1f2;
  --primitiveColorShale975: #f8f8f8;
  --primitiveColorShale1000: #ffffff;
  --primitiveColorSlate25: #070a0c;
  --primitiveColorSlate50: #0d1115;
  --primitiveColorSlate100: #151c22;
  --primitiveColorSlate150: #1b2730;
  --primitiveColorSlate200: #21323e;
  --primitiveColorSlate300: #2d4a5d;
  --primitiveColorSlate450: #3d6c89;
  --primitiveColorSlate750: #a9bbc9;
  --primitiveColorSlate850: #cbd6df;
  --primitiveColorSlate900: #dce3e9;
  --primitiveColorSlate950: #eef1f4;
  --primitiveColorSlate975: #f6f8fa;
  --primitiveColorTeal25: #070a0c;
  --primitiveColorTeal50: #0c1214;
  --primitiveColorTeal100: #141d20;
  --primitiveColorTeal150: #19282d;
  --primitiveColorTeal200: #1e333a;
  --primitiveColorTeal300: #274c57;
  --primitiveColorTeal600: #3f94ac;
  --primitiveColorTeal750: #75c4de;
  --primitiveColorTeal850: #91e0fa;
  --primitiveColorTeal900: #b2edff;
  --primitiveColorTeal950: #d9f5ff;
  --primitiveColorTeal975: #ebfaff;
}
`;